/* global angular*/
import './style.less';
import { specialTopics } from '@prolaera/library';

export default function() {
  const vm = this;

  vm.$onInit = activate;

  vm.topics = specialTopics;

  vm.change = hour => {
    specialTopics.forEach(({ key, secondary_key }) => {
      if (hour[key] || hour[secondary_key]) {
        hour[key] = true;
      }
    });

    vm.specialTopicsSelected = angular
      .copy(specialTopics)
      .filter(({ key, secondary_key }) => hour[key] || hour[secondary_key])
      .map(({ name }) => name);
  };

  function activate() {
    if (vm.ngModel) vm.change(vm.ngModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/specialTopicsDropdown/controller.js